import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils'

type Props = {
  size?: number | string
}

export const AuroraSelfCareEssentialsSpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M32.225 0.239258C27.8073 0.239258 23.5212 0.996819 19.4855 2.49044C9.87754 6.05186 3.12272 13.9474 0.952482 24.1524C-0.481698 30.806 -0.298315 36.9601 1.51654 42.9574C3.83349 50.6164 9.52089 57.0753 17.1205 60.6772C20.8932 62.4693 25.2273 63.4925 30.0003 63.7176C30.6137 63.7454 31.2372 63.7606 31.8569 63.7606C35.6865 63.7606 39.5388 63.2357 43.3076 62.2012C43.5972 62.1291 43.8729 62.0545 44.1638 61.9685C47.5507 60.9769 50.5987 59.4087 53.2065 57.3131C56.0382 55.0505 58.369 52.1822 60.127 48.7927C60.4735 48.125 60.8049 47.4218 61.1704 46.5808C63.1812 41.9114 64.1525 36.6844 63.9805 31.4586C63.8996 29.148 63.5556 26.6919 62.9612 24.1524C61.9823 20.032 60.3862 16.1569 58.345 12.9395C57.786 12.0757 57.2725 11.3497 56.7641 10.6971C53.0952 5.9646 47.3787 2.64347 40.2382 1.098C37.6151 0.528876 34.9188 0.240522 32.2262 0.240522L32.225 0.239258Z'
        fill='white'
        fillOpacity='0.4'
      />
      <Path
        d='M31.5061 50.0446C39.5176 50.0446 46.0122 46.5096 46.0122 42.1489C46.0122 37.7882 39.5176 34.2532 31.5061 34.2532C23.4946 34.2532 17 37.7882 17 42.1489C17 46.5096 23.4946 50.0446 31.5061 50.0446Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M31.9858 35.3011C37.738 34.8857 42.1762 31.7542 41.8987 28.3068C41.6212 24.8594 36.7331 22.4014 30.9808 22.8168C25.2286 23.2322 20.7904 26.3637 21.0679 29.8111C21.3454 33.2585 26.2335 35.7165 31.9858 35.3011Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M37.9679 19.5939C38.422 17.142 35.8868 14.6718 32.3053 14.0767C28.7237 13.4816 25.4522 14.9869 24.9981 17.4389C24.5439 19.8908 27.0792 22.361 30.6607 22.9561C34.2422 23.5512 37.5138 22.0459 37.9679 19.5939Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
